import { render, staticRenderFns } from "./FolderSettingsModal.vue?vue&type=template&id=39f8bc74&scoped=true"
import script from "./FolderSettingsModal.vue?vue&type=script&lang=js"
export * from "./FolderSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./FolderSettingsModal.vue?vue&type=style&index=0&id=39f8bc74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f8bc74",
  null
  
)

export default component.exports